import { FC, ReactNode } from 'react';
import { EasyField } from 'react-bootstrap-formutil';
import BaseAddress, { BaseAddressProps } from 'components/forms/HomeAddress/CommonHomeAddress/BaseAddress';
import type { FormCheckType } from 'types/common';
import type { CustomerInfoKeyType } from 'types/customer';
import classlist from 'utils/classlist';
import DeliveryCountry from '../components/DeliveryCountry';
import { BaseDeliveryAddressProps, DeliveryAddressTypeEnum } from '../type';

export interface CommonDeliveryAddressFormutil {
    delivery_country: string;
    delivery_state: string;
    delivery_city: string;
    delivery_detail: string;
    delivery_postal: string;
    delivery_address_type: DeliveryAddressTypeEnum;
}

export interface CommonDeliveryAddressProps extends Omit<BaseAddressProps, 'prefix'>, BaseDeliveryAddressProps {
    title?: ReactNode;
}

/**
 * @description 获取邮寄地址对应的默认表单项字段的数组
 * @param sameDeliveryAndResidence same_delivery_and_residence，我的邮寄地址与居住地址不同对应的字段
 */
export function getFieldsOfCommonDeliveryAddress(
    sameDeliveryAndResidence: FormCheckType | undefined,
    needDeliveryAddressType: boolean = true
) {
    const baseFields: CustomerInfoKeyType[] =
        sameDeliveryAndResidence === '0'
            ? ['delivery_state', 'delivery_city', 'delivery_detail', 'delivery_postal', 'delivery_country']
            : [];

    return needDeliveryAddressType ? baseFields.concat('delivery_address_type') : baseFields;
}

const Common: FC<CommonDeliveryAddressProps> = ({
    title = __('MAILING ADDRESS'),
    disabled,
    className,
    hasCountry,
    deliveryCountry,
    ...restProps
}) => {
    return (
        <div className={classlist('common-delivery-address-root', className)}>
            {title && <h3 className="open-title mt-4">{title}</h3>}
            {hasCountry && <DeliveryCountry $defaultValue={deliveryCountry} disabled={disabled} />}
            <BaseAddress prefix="delivery" disabled={disabled} hideMailAddress label={null} {...restProps} />
            <EasyField name="delivery_address_type" type="hidden" $defaultValue={DeliveryAddressTypeEnum.COMMON} />
        </div>
    );
};

export default Common;
